<template>
  <div style="width: 100%">
    <v-card outlined class="px-3" width="100%">
      <v-container>
        <h4 style="margin-left: -12px;" class="mb-1">Description</h4>
        <v-row class="">
          <v-text-field
            v-model="shortDescriptionCustom"
            type="text"
            label="Short Description"
            :counter="128"

            class="width-100"
            required
          ></v-text-field>
        </v-row>
        <p style="margin-left: -12px;" class="theme--light v-label my-2">Full Description</p>
        <v-row class="d-inline-block" style="width: 100%">
          <vue-editor :editorToolbar="customToolbar" v-model="fullDescriptionCustom"></vue-editor>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
  name: 'EventsDescriptionCard',
  components: {
    VueEditor
  },
  props: {
    shortDescription: {
      type: String,
      require: false,
      default: ''
    },
    fullDescription: {
      type: String,
      require: false,
      default: ''
    }
  },
  watch: {
    shortDescription(newValue) {
      this.shortDescriptionCustom = newValue;
    },
    fullDescription(newValue) {
      this.fullDescriptionCustom = newValue;
    },
    shortDescriptionCustom(newValue) {
      this.$emit('update:shortDescription', newValue);
    },
    fullDescriptionCustom(newValue) {
      this.$emit('update:fullDescription', newValue);
    }
  },
  data() {
    return {
      shortDescriptionCustom: this.shortDescription,
      fullDescriptionCustom: this.fullDescription,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
        [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent

        [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown

        [{'color': []}, {'background': []}],          // dropdown with defaults from theme
        [{'font': []}],
        [{'align': []}],

        ['clean']                                         // remove formatting button
      ]
    }
  }
}
</script>
<style>
.quillWrapper {
  width: 100%;
  height: 30vh;
}

#full-description-editor {
  width: 100%
}
</style>
